/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Dl_Web_2Inputs */

const en_pc_dl_web_2 = /** @type {(inputs: Pc_Dl_Web_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To self-host, download the web .zip and upload its contents to any static host. All URLs inside are relative.`)
};

const zh_pc_dl_web_2 = /** @type {(inputs: Pc_Dl_Web_2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如需自行部署，下载网页版 .zip，把内容上传到任意静态托管服务，其中所有路径都是相对路径。`)
};

/**
* | output |
* | --- |
* | "To self-host, download the web .zip and upload its contents to any static host. All URLs inside are relative." |
*
* @param {Pc_Dl_Web_2Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_dl_web_2 = /** @type {((inputs?: Pc_Dl_Web_2Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Dl_Web_2Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_dl_web_2(inputs)
	return zh_pc_dl_web_2(inputs)
});
export { pc_dl_web_2 as "pc.dl.web.2" }